import baseAPI from "@/http";

const router = "api/usuario";

export const userAPI = {
  create: (user) => baseAPI.post(router + "/cadastrar-usuario", user),
  update: (user) => baseAPI.put(router, user),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  listConsultant: () => baseAPI.get(router + "/consultoresByMunicipio"),
  listConsultores: () => baseAPI.get(router + "/consultores"),
  criarComSenhaTemporaria: (user) =>
    baseAPI.post(router + "/criar-com-senha-temporaria", user),
  enviarCodigoValidacao: (data) =>
    baseAPI.post(router + "/enviar-codigo-validacao", data),
  verificarCodigoValidacao: (data) =>
    baseAPI.post(router + "/verificar-codigo-validacao", data),
  recuperarSenha: (user) => baseAPI.post(router + "/recuperar-senha", user),
  trocarSenha: (user) => baseAPI.post(router + "/trocar-senha", user),
  updateUser: (user) => baseAPI.put(router + "/atualizar-usuario", user),
  get: (id) => baseAPI.get(`${router}/${id}`),
  findUser: (id) => baseAPI.get(`${router}/find-user/${id}`),
  listADs: () => baseAPI.get(router + "/ads"),
  getByCPF: (cpf) => baseAPI.get(`${router}/get-by-cpf/${cpf}`),
  sendSignature: (user) =>
    baseAPI.post(router + "/enviar-assinatura-eletronica", user),
  getByFilter: (filtro) => baseAPI.post(router + "/get-by-filtro", filtro),
  testePDF: () => baseAPI.get(`${router}/teste-pdf`, { responseType: "blob" }),
  habilitarDesabilitarUser: (user) =>
    baseAPI.post(router + "/habilitar-desabilitar-usuario", user),
  verifyEmail: (email) => baseAPI.get(router + "/find-user-by-email/" + email),
  verificarToken: (token) =>
    baseAPI.post(router + "/verifica-token-valido?token=" + token),
  verificarPrimeiroCadastro: (data) =>
    baseAPI.post(router + "/verificar-primeiro-cadastro", data),
  definirSenhaPrimeiroAcesso: (data) =>
    baseAPI.post(router + "/definir-senha-primeiro-acesso", data),
};
